import gql from 'graphql-tag';

const CREATE_COMMENT_ON_DEVICE = gql`
  mutation createCommentOnDevice(
    $deviceSerialNo: String
    $note: String
    $imageAttachments: [String]
    $fromStage: String
    $toStage: String
  ) {
    createCommentOnDevice(
      deviceSerialNo: $deviceSerialNo
      note: $note
      imageAttachments: $imageAttachments
      fromStage: $fromStage
      toStage: $toStage
    ) {
      code
      comment {
        deviceSerialNo
        createdBy
        updatedOn
        fromStage
        toStage
        imageAttachments
        _id
        note
        creatorName
        createdOn
      }
    }
  }
`;

export default CREATE_COMMENT_ON_DEVICE;
